import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PageLoader = () => {
  const [showRetry, setShowRetry] = useState(false);

  // Show retry button after 10 seconds of loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowRetry(true);
    }, 10000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <>
      {/* Progress bar at top for immediate feedback */}
      <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-primary/20">
        <div className="h-full bg-primary w-1/3 animate-[loading_1s_ease-in-out_infinite]" />
      </div>
      
      <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4">
        <div className="w-10 h-10 rounded-full border-2 border-transparent border-t-primary animate-spin" />
        
        {showRetry && (
          <div className="text-center space-y-3 animate-in fade-in duration-300">
            <p className="text-sm text-muted-foreground">
              Taking longer than expected...
            </p>
            <Button variant="outline" size="sm" onClick={handleRetry} className="gap-2">
              <RefreshCw className="w-4 h-4" />
              Refresh
            </Button>
          </div>
        )}
      </div>
    </>
  );
};